import React, { useEffect } from 'react'
import { motion, useAnimation } from 'framer-motion'
import { Link } from 'react-router-dom'
import logo from "../assets/galantisyellow.svg"
import "../css/logo.css"

const Logo = ({ inView, showNav }) => {

  const animation = useAnimation()

useEffect(() => {
      if(inView){
          animation.start({ y: '300%', filter: 'blur(5px)', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, } })
      }
      if(!inView || showNav){
          animation.start({ y: '0%', filter: 'blur(0.5px)', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 1 } })
      }
  }, [inView, showNav])


  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { duration: 0.7, delay: 3 } }} className='logo-main' style={{ overflow: 'hidden' }}>
      <motion.div animate={ animation }>
      <Link to="/">
        <img src={ logo } alt="logo" style={{ opacity: 1 }} />
      </Link>
      </motion.div>
    </motion.div>
  )
}

export default Logo